import { useMemo } from "react";
import useDataTableFilters from "./useDataTableFilters";
import useDataTablePagination from "./useDataTablePagination";
import useDataTableSorting from "./useDataTableSorting";
import useDataTableColoring from "./useDataTableColoring";


const useDataTable = (props) => {
    const paginationState = useDataTablePagination(props);
    const sortingState = useDataTableSorting(props);
    const filtersState = useDataTableFilters({...props, onFilterChanged: paginationState.goToFirstPage});
    const coloringState = useDataTableColoring(props);

    // I should use a memo here because the prefetch query is called on every
    // time the fetch data options changes
    const fetchDataOptions = useMemo(() => ({
        ...paginationState.paginationFetchOptions,
        ...filtersState.filterFetchOptions,
        ...sortingState.sortingFetchOptions,
    }), [
        paginationState.paginationFetchOptions,
        filtersState.filterFetchOptions,
        sortingState.sortingFetchOptions
    ]);

    return {
        ...paginationState,
        ...sortingState,
        ...filtersState,
        ...coloringState,
        fetchDataOptions,
        dataTableId: props?.dataTableId,
    }
}

export default useDataTable;